import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b871fb36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report bg-white relative overflow-y-scroll" }
const _hoisted_2 = { class: "header w-full fixed relative flex" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-data body" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "font-bold inline-block" }, "Report dipendente")
], -1))
const _hoisted_4 = { class: "text-right ml-auto" }
const _hoisted_5 = { class: "body text-left h-full" }
const _hoisted_6 = { class: "user-data" }
const _hoisted_7 = { class: "period-selector pb-8" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-primary-900 text-left" }, "Seleziona il periodo", -1))
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = ["value"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "w-6 h-5 mx-4",
  fill: "#032C72",
  viewbox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M14 5l7 7m0 0l-7 7m7-7H3"
  })
], -1))
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-primary-900 pb-8" }, "Informazioni del dipendente", -1))
const _hoisted_14 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_15 = { class: "name text-input" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Nome", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 1,
  class: "bg-primary-100",
  id: "name",
  type: "text",
  placeholder: ""
}
const _hoisted_19 = { class: "surname text-input" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Cognome", -1))
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  key: 1,
  class: "bg-primary-100",
  id: "surname",
  type: "text",
  placeholder: ""
}
const _hoisted_23 = { class: "total-data" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-primary-900 pb-1" }, "Totali", -1))
const _hoisted_25 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_26 = { class: "working-hours text-input" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Ore ordinarie", -1))
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "travelling-seconds text-input" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Giorni lavorati", -1))
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "overtime25 text-input" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Straordinari 25%", -1))
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "overtime50 text-input" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Straordinari 50%", -1))
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "travelling-seconds text-input" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Buoni pasto", -1))
const _hoisted_40 = ["value"]
const _hoisted_41 = { class: "travelling-seconds text-input" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Ore viaggio", -1))
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "report-table" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-primary-900 pb-1" }, "Ore", -1))
const _hoisted_46 = { class: "table-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_client_table = _resolveComponent("v-client-table")!
  const _component_DownloadReportDialog = _resolveComponent("DownloadReportDialog")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_PrimaryButton, {
          class: "bg-primary-900 chat-button text-white m-auto",
          onClick: _ctx.downloadSelectedReport
        }, {
          default: _withCtx(() => [
            _createTextVNode("Scarica Report")
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_v_date_picker, {
            "onUpdate:modelValue": _ctx.onSelectedDateValue,
            "model-value": _ctx.selectedDate,
            "is-range": ""
          }, {
            default: _withCtx(({ inputValue, inputEvents }) => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("input", _mergeProps({
                  class: "bg-primary-50 rounded w-28 p-1",
                  value: inputValue.start
                }, _toHandlers(inputEvents.start, true), { placeholder: "GG/MM/ANNO" }), null, 16, _hoisted_10),
                _hoisted_11,
                _createElementVNode("input", _mergeProps({
                  class: "bg-primary-50 rounded w-28 p-1",
                  value: inputValue.end
                }, _toHandlers(inputEvents.end, true), { placeholder: "GG/MM/ANNO" }), null, 16, _hoisted_12)
              ])
            ]),
            _: 1
          }, 8, ["onUpdate:modelValue", "model-value"])
        ]),
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            (_ctx.employee != undefined)
              ? (_openBlock(), _createElementBlock("input", {
                  key: 0,
                  id: "name",
                  type: "text",
                  placeholder: "Nome dipendente",
                  value: _ctx.employee.name,
                  readonly: ""
                }, null, 8, _hoisted_17))
              : (_openBlock(), _createElementBlock("input", _hoisted_18))
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            (_ctx.employee != undefined)
              ? (_openBlock(), _createElementBlock("input", {
                  key: 0,
                  id: "surname",
                  type: "text",
                  placeholder: "Cognome dipendente",
                  value: _ctx.employee.surname,
                  readonly: ""
                }, null, 8, _hoisted_21))
              : (_openBlock(), _createElementBlock("input", _hoisted_22))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("input", {
              id: "name",
              type: "number",
              placeholder: "-",
              value: _ctx.totals.workingHours.toFixed(2),
              readonly: ""
            }, null, 8, _hoisted_28)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("input", {
              id: "surname",
              type: "number",
              placeholder: "-",
              value: _ctx.totals.days,
              readonly: ""
            }, null, 8, _hoisted_31)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createElementVNode("input", {
              id: "name",
              type: "number",
              placeholder: "-",
              value: _ctx.totals.overtime25.toFixed(2),
              readonly: ""
            }, null, 8, _hoisted_34)
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createElementVNode("input", {
              id: "surname",
              type: "number",
              placeholder: "-",
              value: _ctx.totals.overtime50.toFixed(2),
              readonly: ""
            }, null, 8, _hoisted_37)
          ]),
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _createElementVNode("input", {
              id: "surname",
              type: "number",
              placeholder: "-",
              value: _ctx.totals.foodStamps,
              readonly: ""
            }, null, 8, _hoisted_40)
          ]),
          _createElementVNode("div", _hoisted_41, [
            _hoisted_42,
            _createElementVNode("input", {
              id: "surname",
              type: "number",
              placeholder: "-",
              value: _ctx.secondsToFormattedHours(_ctx.totals.travellingSeconds),
              readonly: ""
            }, null, 8, _hoisted_43)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_44, [
        _hoisted_45,
        _createElementVNode("div", _hoisted_46, [
          _createVNode(_component_v_client_table, {
            data: _ctx.reports,
            columns: _ctx.tableColumns,
            options: _ctx.tableOptions
          }, null, 8, ["data", "columns", "options"])
        ])
      ])
    ]),
    (_ctx.downloadReport)
      ? (_openBlock(), _createBlock(_component_DownloadReportDialog, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.hideDownloadReportDialog()))
        }))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 1,
          message: "Download..."
        }))
      : _createCommentVNode("", true)
  ]))
}